import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { useTranslate } from 'react-admin'

import { green, red } from '../../constants/colorConstants'
import Ellipse from '../../images/ellipse'

const useStyles = makeStyles((theme) => ({
  greenStatusField: {
    ...theme.mundi.font.roboto700Normal,
    color: green,
    whiteSpace: 'nowrap',
    fontSize: '14px',
    lineHeight: '16.41px',
  },
  redStatusField: {
    ...theme.mundi.font.roboto700Normal,
    color: red,
    whiteSpace: 'nowrap',
    fontSize: '14px',
    lineHeight: '16.41px',
  },
  ellipse: {
    display: 'inline',
    marginRight: '5px',
    marginBottom: '2px',
  },
}))

export const CreditLineStatusField = ({
  source,
  record,
  basePath,
  ...props
}) => {
  const classes = useStyles()
  const translate = useTranslate()
  return (
    <Typography variant="span" {...props}>
      {record[source] === 'active' && (
        <>
          <span className={classes.greenStatusField}>
            <Ellipse className={classes.ellipse} color={green} />
            {translate('resources.creditlines.creditline.activeStatus')}
          </span>
        </>
      )}
      {record[source] === 'open' && (
        <>
          <span className={classes.greenStatusField}>
            <Ellipse className={classes.ellipse} color={green} />
            {translate('resources.creditlines.creditline.openStatus')}
          </span>
        </>
      )}
      {record[source] === 'closed' && (
        <>
          <span className={classes.redStatusField}>
            <Ellipse className={classes.ellipse} color={red} />
            {translate('resources.creditlines.creditline.cloedStatus')}
          </span>
        </>
      )}
    </Typography>
  )
}
